<lib-modal
  [visible]="visible()"
  [title]="'modules.form.testdatenblaetter.dialog.title' | translate"
  [contentTemplate]="resolvedContentTemplate ?? undefined"
  [showButtons]="false"
  (cancel)="onCancel()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #embedContent>
  <div class="ted">
    <p class="ted__subtitle">{{ 'modules.form.testdatenblaetter.dialog.subtitle' | translate }}</p>

    <mat-form-field appearance="fill" class="ted__search">
      <mat-label>{{ 'modules.form.testdatenblaetter.dialog.searchPlaceholder' | translate }}</mat-label>
      <input matInput [value]="searchTerm()" (input)="onSearch($event)" />
    </mat-form-field>

    @if (loading()) {
      <div class="ted__loading">
        <mat-spinner diameter="28" />
      </div>
    } @else if (error()) {
      <p class="ted__error" role="alert">{{ 'modules.form.testdatenblaetter.dialog.loadError' | translate }}</p>
    } @else if (filtered().length === 0) {
      <p class="ted__empty">{{ 'modules.form.testdatenblaetter.dialog.empty' | translate }}</p>
    } @else {
      <ul class="ted__list">
        @for (sheet of filtered(); track sheet.id) {
          <li class="ted__item">
            <mat-checkbox
              [checked]="isSelected(sheet.id)"
              (change)="toggle(sheet.id)"
              [attr.aria-label]="('modules.form.testdatenblaetter.dialog.selectAria' | translate) + ' ' + sheet.name"
            >
              <span class="ted__row">
                <code class="ted__id">{{ sheet.key }}</code>
                <span class="ted__text">
                  <span class="ted__name">{{ sheet.name }}</span>
                  <span class="ted__meta">
                    {{
                      'modules.form.testdatenblaetter.dialog.meta'
                        | translate: { rows: sheet.zeilen.length, vars: sheet.spalten.length }
                    }}
                  </span>
                </span>
              </span>
            </mat-checkbox>
          </li>
        }
      </ul>
    }

    <div class="ted__footer">
      <button
        mat-stroked-button
        type="button"
        class="ted__footer-btn"
        data-testid="tdb-dialog-cancel"
        (click)="onCancel()"
      >
        {{ 'modules.form.testdatenblaetter.dialog.cancel' | translate }}
      </button>
      <button
        mat-stroked-button
        type="button"
        class="ted__footer-btn"
        data-testid="tdb-dialog-create-new"
        (click)="onCreateNew()"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        {{ 'modules.form.testdatenblaetter.dialog.createNew' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="ted__footer-btn ted__footer-btn--primary"
        data-testid="tdb-dialog-apply"
        [disabled]="!canApply()"
        (click)="onApply()"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        @if (selectedCount() > 0) {
          {{ 'modules.form.testdatenblaetter.dialog.applyN' | translate: { count: selectedCount() } }}
        } @else {
          {{ 'modules.form.testdatenblaetter.dialog.apply' | translate }}
        }
      </button>
    </div>
  </div>
</ng-template>
